/**
 * MeMark AI Smart Auto-Tagger & Domain Classifier
 * High-speed client-side heuristic classifier that inspects URLs and titles
 * to assign structured tags and categorical grouping.
 */

export function inferSmartTags(url = '', title = '') {
  const text = `${url} ${title}`.toLowerCase();
  const tags = new Set();

  // Developer & Infrastructure
  if (
    text.includes('github') || text.includes('gitlab') || text.includes('stackoverflow') ||
    text.includes('npmjs') || text.includes('dev.to') || text.includes('vercel') ||
    text.includes('cloudflare') || text.includes('docker') || text.includes('kubernetes') ||
    text.includes('api') || text.includes('sdk') || text.includes('repo')
  ) {
    tags.add('#dev');
    tags.add('#code');
  }

  // AI & Machine Learning
  if (
    text.includes('openai') || text.includes('claude') || text.includes('anthropic') ||
    text.includes('huggingface') || text.includes('openrouter') || text.includes('llm') ||
    text.includes('deepseek') || text.includes('midjourney') || text.includes('gpt') ||
    text.includes('machine learning') || text.includes('agent')
  ) {
    tags.add('#ai');
    tags.add('#ml');
  }

  // Design, UI & Creative
  if (
    text.includes('figma') || text.includes('dribbble') || text.includes('behance') ||
    text.includes('framer') || text.includes('unsplash') || text.includes('font') ||
    text.includes('icon') || text.includes('color') || text.includes('design') ||
    text.includes('ui') || text.includes('ux') || text.includes('awwwards')
  ) {
    tags.add('#design');
    tags.add('#ui');
  }

  // Media, Audio & Video
  if (
    text.includes('youtube') || text.includes('vimeo') || text.includes('twitch') ||
    text.includes('spotify') || text.includes('soundcloud') || text.includes('netflix') ||
    text.includes('podcast') || text.includes('video') || text.includes('audio')
  ) {
    tags.add('#media');
  }

  // Finance, Web3 & Crypto
  if (
    text.includes('coingecko') || text.includes('coinmarketcap') || text.includes('binance') ||
    text.includes('stripe') || text.includes('bloomberg') || text.includes('tradingview') ||
    text.includes('crypto') || text.includes('finance') || text.includes('bitcoin') ||
    text.includes('defi') || text.includes('solana')
  ) {
    tags.add('#finance');
    tags.add('#crypto');
  }

  // Cybersecurity & Privacy
  if (
    text.includes('virustotal') || text.includes('eff.org') || text.includes('privacy') ||
    text.includes('security') || text.includes('vault') || text.includes('cve') ||
    text.includes('owasp') || text.includes('crypto') || text.includes('shield') ||
    text.includes('adblock')
  ) {
    tags.add('#security');
    tags.add('#privacy');
  }

  // Longform Reading, Research & Documentation
  if (
    text.includes('medium.com') || text.includes('substack.com') || text.includes('wikipedia') ||
    text.includes('arxiv') || text.includes('nature.com') || text.includes('nytimes') ||
    text.includes('docs.') || text.includes('guide') || text.includes('tutorial') ||
    text.includes('book') || text.includes('read')
  ) {
    tags.add('#reading');
    tags.add('#research');
  }

  if (tags.size === 0) {
    tags.add('#tools');
  }

  return Array.from(tags);
}
